(() => {
  'use strict';
  if (customElements.get('oeo-choice-media')) return;
  class ChoiceMedia extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._form = this.closest('form');
      this._root = this._form?.querySelector('[data-oeo-artwork-choices]') || this.closest('#oeoChoices');
      this._product = this.closest('product-info');
      if (!this._root || !this._product) return;
      this._bound = true;
      this._revision = 0;
      this._change = event => {
        if (event.target.matches('input[data-oeo-media-id], select[data-oeo-media-select]')) this.activateSelected();
      };
      this._variant = event => {
        const current = this._form?.querySelector('input[name="id"]')?.value;
        if (!current) return;
        if (String(event.detail?.variant?.id) === String(current)) this.activateSelected();
      };
      this._page = () => this.activateSelected();
      this._root.addEventListener('change', this._change);
      this._root.addEventListener('click', this._change);
      document.addEventListener('variant:changed', this._variant);
      window.addEventListener('load', this._page);
      window.addEventListener('pageshow', this._page);
      this.activateSelected();
      this._frame = requestAnimationFrame(() => this.activateSelected());
    }
    async activateSelected() {
      const revision = ++this._revision;
      const input = this._root.querySelector('input[data-oeo-media-id]:checked, select[data-oeo-media-select] option:checked');
      const id = input?.dataset.oeoMediaId;
      if (!id || !/^[1-9]\d*$/.test(id)) return;
      await customElements.whenDefined('media-gallery');
      if (!this.isConnected || revision !== this._revision) return;
      const gallery = this._product.querySelector('media-gallery');
      if (!gallery) return;
      const item = [...gallery.querySelectorAll('.product__media-item')].find(node => node.dataset.mediaId === id);
      if (!item) return;
      if (!gallery.elements && typeof gallery.init === 'function') gallery.init();
      const slider = gallery.sliderInstance?.slider;
      if (slider && !slider.destroyed) {
        const index = [...slider.slides].findIndex(node => node.dataset.mediaId === id);
        if (index < 0) return;
        slider.slideTo(index, 0, true);
        slider.updateAutoHeight(0);
        slider.thumbs?.update?.();
        gallery.thumbsInstance?.slider?.slideTo(index, 0);
      } else if (typeof gallery.sortMediaItems === 'function') {
        gallery.sortMediaItems({featured_media: {id}});
      }
      this.dataset.activeMedia = id;
    }
    disconnectedCallback() {
      if (!this._bound) return;
      this._revision++;
      cancelAnimationFrame(this._frame);
      this._root.removeEventListener('change', this._change);
      this._root.removeEventListener('click', this._change);
      document.removeEventListener('variant:changed', this._variant);
      window.removeEventListener('load', this._page);
      window.removeEventListener('pageshow', this._page);
      this._bound = false;
    }
  }
  customElements.define('oeo-choice-media', ChoiceMedia);
})();
